module.exports = __webpack_public_path__ + "static/media/icon_3.b2aaf107.png";